import React, { useEffect, useState } from "react";
import TableComponent from "../../Global Functions/tableComponents";
import { columnsRefunds } from "../../Global Functions/columnsAntd";
import { useDispatch, useSelector } from "react-redux";
import { viewRefundsList } from "../../Redux/Actions/walletRefundAction";

const ListRefunds = () => {
  const dispatch = useDispatch();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchDetails = (page, limit) => {
    const refundData = {
      page,
      limit,
      is_deleted: false,
    };

    dispatch(viewRefundsList(refundData));
  };

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { refunds } = useSelector((state) => state.refunds || {});

  useEffect(() => {
    if (refunds?.total) {
      setPagination((prevData) => ({ ...prevData, total: refunds.total }));
    }
  }, [refunds]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchDetails(pagination.current, pagination.pageSize);
  };

  return (
    <TableComponent
      columns={columnsRefunds}
      h3heading="Wallet Refunds"
      handleTableChange={handleTableChange}
      dataSource={Array.isArray(refunds?.data) ? refunds.data : []}
    ></TableComponent>
  );
};

export default ListRefunds;
